'use client';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { setSearchPopup } from '@/redux/actions/common.action';
import { AppDispatch, RootState } from '@/redux/store';
import { ChevronLeft, Search, X } from 'lucide-react';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SearchList, TrendingList } from './components';

const SearchDialog = () => {
  const initialState = {
    searchQuery: '',
    tab: 'all',
  }
  const dispatch = useDispatch<AppDispatch>();

  const isSearchDialogOpen = useSelector(
    (state: RootState) => state.common.isSearchPopupOpen,
  );
  const [state, setState] = useState(initialState);

  const onStateChange = (key: string, value: string) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  }

  const onOpenChange = () => {
    dispatch(setSearchPopup(false));
  };

  const handleClearSearch = () => {
    onStateChange('searchQuery', '');
  }

  return (
    <Dialog open={isSearchDialogOpen} onOpenChange={onOpenChange}>
      <DialogContent className='flex h-full w-full max-w-full flex-col rounded-none p-0 md:h-[600px] md:max-w-3xl md:rounded-2xl [&>button:last-child]:text-white [&_.dialogClose]:hidden'>
        <DialogHeader>
          <DialogTitle className='flex flex-col justify-center bg-gradient-to-r p-6 pb-0 text-black'>
            <div className='mb-3 size-8 border rounded-lg sm:hidden flex justify-center items-center'>
              <ChevronLeft
                className='text-muted-foreground'
                size={20}
                onClick={() => dispatch(setSearchPopup(false))}
              />
            </div>
            <div className='relative flex items-center gap-2 md:gap-4 w-full border-[1.5px] rounded-lg px-4 bg-white'>
              <Search
                className='text-muted-foreground'
                size={24}
              />
              <div className='h-5 w-[1px] bg-gray-300' />
              <Input
                placeholder='Search for events, categories...'
                value={state.searchQuery}
                onChange={(e) => onStateChange('searchQuery', e.target.value)}
                className='border-none outline-none p-0 focus-visible:ring-0 font-medium text-sm'
              />
              <div className='bg-gray-200 rounded-full p-1' onClick={handleClearSearch}>
                <X className='text-muted-foreground' size={12} />
              </div>
            </div>
          </DialogTitle>
        </DialogHeader>
        {state.searchQuery.length >= 3 ? <SearchList queryString={state.searchQuery} /> : <TrendingList />}
      </DialogContent>
    </Dialog>
  );
}

export default SearchDialog;
